module.exports = __webpack_public_path__ + "static/media/hygiene.14918bce.png";